export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/fr.lyaml"));
at({ "fr": { "public": { "sampleString": "Cha\xEEne d'exemple" } } });
};